const indexItems = [
  { id: 1, title: '国产热播剧', count: '128部', desc: '最新上线的国产电视剧全集', icon: 'ri-fire-line', color: 'bg-accent-100 text-accent-700' },
  { id: 2, title: '韩剧精选', count: '86部', desc: '高分韩剧韩语中字全集', icon: 'ri-heart-line', color: 'bg-primary-100 text-primary-700' },
  { id: 3, title: '古装传奇', count: '65部', desc: '古装权谋仙侠武侠合集', icon: 'ri-sword-line', color: 'bg-secondary-100 text-secondary-700' },
  { id: 4, title: '悬疑探案', count: '53部', desc: '烧脑悬疑推理剧全集', icon: 'ri-search-eye-line', color: 'bg-accent-100 text-accent-700' },
  { id: 5, title: '都市情感', count: '72部', desc: '现实题材都市生活剧集', icon: 'ri-building-line', color: 'bg-primary-100 text-primary-700' },
  { id: 6, title: '美剧英剧', count: '94部', desc: '海外高分原声剧集全集', icon: 'ri-global-line', color: 'bg-secondary-100 text-secondary-700' },
  { id: 7, title: '日剧泰剧', count: '41部', desc: '日剧泰剧精选全集播放', icon: 'ri-earth-line', color: 'bg-accent-100 text-accent-700' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            剧集索引
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">剧集索引 · 全品类电视剧导航</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">覆盖七大剧集类型，快速定位你想看的电视剧</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#ranking"
              className="group flex flex-col items-center text-center p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 rounded-xl ${item.color} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-sm text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">{item.title}</h3>
              <span className="text-xs text-foreground-400 mb-1">{item.count}</span>
              <span className="text-xs text-foreground-500">{item.desc}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}